const vi = {
  brand: "Bánh Bao Admin",
  tagline: "Hệ thống quản lý nội bộ tiệm bánh bao",
  nav: {
    dashboard: "Tổng quan",
    orders: "Đơn hàng",
    products: "Sản phẩm",
    materials: "Nguyên vật liệu",
    production: "Kho hàng hóa",
    stockIn: "Nhập kho",
    customers: "Khách hàng",
    customerCare: "Chăm sóc KH",
    insights: "AI Insights",
    suppliers: "Nhà cung cấp",
    debts: "Công nợ",
    delivery: "Giao hàng",
    users: "Nhân viên",
    reports: "Báo cáo",
    finance: "Thu Chi & Lợi Nhuận",
    settings: "Cài đặt",
  },
  common: {
    search: "Tìm kiếm...",
    add: "Thêm mới",
    edit: "Sửa",
    delete: "Xóa",
    cancel: "Hủy",
    save: "Lưu",
    confirm: "Xác nhận",
    actions: "Thao tác",
    yes: "Có",
    no: "Không",
    loading: "Đang tải...",
    empty: "Chưa có dữ liệu",
    saved: "Đã lưu",
    deleted: "Đã xóa",
    error: "Có lỗi xảy ra",
    today: "Hôm nay",
    total: "Tổng",
    name: "Tên",
    phone: "Số điện thoại",
    email: "Email",
    address: "Địa chỉ",
    district: "Phường/Xã",
    city: "Tỉnh/Thành phố",
    status: "Trạng thái",
    quantity: "Số lượng",
    price: "Giá",
    notes: "Ghi chú",
    close: "Đóng",
    back: "Quay lại",
    update: "Cập nhật",
    create: "Tạo mới",
    filter: "Lọc",
    all: "Tất cả",
    logout: "Đăng xuất",
    welcome: "Xin chào",
    language: "Ngôn ngữ",
    import: "Nhập",
    export: "Xuất",
    template: "Tải form mẫu",
    sort: "Sắp xếp",
    ascending: "Tăng dần",
    descending: "Giảm dần",
    print: "In",
    pdf: "Xuất PDF",
    duplicate: "Nhân bản",
    copy: "Sao chép",
    reBuy: "Mua lại",
  },
  auth: {
    login: "Đăng nhập",
    loginTitle: "Đăng nhập",
    loginSubtitle: "Quản lý tiệm bánh bao của bạn dễ dàng hơn bao giờ hết",
    password: "Mật khẩu",
    forgot: "Quên mật khẩu?",
    or: "hoặc",
    googleLogin: "Đăng nhập với Google",
    submit: "Đăng nhập",
    invalid: "Email hoặc mật khẩu không đúng",
  },
  dashboard: {
    title: "Tổng quan",
    subtitle: "Tổng kết hoạt động kinh doanh trong hôm nay",
    todayRevenue: "Doanh thu hôm nay",
    todayOrders: "Đơn hàng hôm nay",
    totalDebt: "Công nợ",
    totalProducts: "Sản phẩm",
    revenueChart: "Doanh thu 7 ngày gần nhất",
    lowStock: "Cảnh báo tồn kho",
    recentOrders: "Đơn hàng gần đây",
    topProducts: "Top bán chạy",
    quickActions: "Thao tác nhanh",
    newOrder: "Tạo đơn mới",
    sold: "Đã bán",
    inStock: "Còn",
    inactiveCustomers: "KH chưa đặt 14+ ngày",
    lowStockMaterials: "NVL sắp hết",
    serverTime: "Giờ hệ thống",
  },
  orders: {
    title: "Quản lý đơn hàng",
    new: "Tạo đơn hàng",
    code: "Mã đơn",
    customer: "Khách hàng",
    items: "Sản phẩm",
    total: "Tổng tiền",
    date: "Ngày đặt",
    dueDate: "Hạn thanh toán",
    payment: "Thanh toán",
    type: "Loại đơn",
    timeline: "Lịch sử trạng thái",
    addItem: "Thêm sản phẩm",
    selectCustomer: "Chọn khách hàng",
    selectProduct: "Chọn sản phẩm",
    subtotal: "Tạm tính",
    discount: "Giảm giá",
    shipping: "Phí vận chuyển",
    paid: "Đã thanh toán",
    unpaid: "Chưa thanh toán",
    partiallyPaid: "Thanh toán 1 phần",
    detail: "Chi tiết đơn hàng",
    updateStatus: "Cập nhật trạng thái",
    statusNote: "Ghi chú trạng thái",
    shipper: "Người giao",
    assignShipper: "Phân công shipper",
    retail: "Bán lẻ",
    wholesale: "Bán sỉ",
    delivery: "Giao hàng",
    duplicate: "Nhân bản đơn",
  },
  status: {
    new: "Mới",
    processing: "Đang xử lý",
    preparing: "Đang chuẩn bị",
    delivering: "Đang giao",
    delivered: "Đã giao",
    debt_pending: "Còn nợ",
    cancelled: "Đã hủy",
  },
  payment: {
    cash: "Tiền mặt",
    transfer: "Chuyển khoản",
    debt: "Công nợ",
    cod: "Công nợ",
    ewallet: "Ví điện tử",
    card: "Thẻ",
  },
  products: {
    title: "Quản lý sản phẩm",
    name: "Tên sản phẩm",
    sku: "Mã SKU",
    category: "Danh mục",
    description: "Mô tả",
    cost: "Giá vốn",
    wholesalePrice: "Giá sỉ",
    stock: "Tồn kho",
    lowStockThreshold: "Ngưỡng cảnh báo",
    unit: "Đơn vị",
    image: "Hình ảnh",
    active: "Đang bán",
    inactive: "Ngừng bán",
    lowStockOnly: "Chỉ tồn thấp",
  },
  materials: {
    title: "Nguyên vật liệu (NVL)",
    new: "Thêm NVL",
    name: "Tên NVL",
    code: "Mã NVL",
    expirationDays: "HSD mặc định (ngày)",
    productionDate: "Ngày sản xuất",
    expirationDate: "Hạn sử dụng",
    batch: "Lô",
  },
  stock: {
    in: "Nhập kho",
    out: "Xuất kho",
    adjust: "Điều chỉnh",
    movements: "Lịch sử nhập/xuất",
    expiring: "Sắp hết hạn",
    reason: "Lý do",
    reasons: {
      damage: "Hư hỏng",
      waste: "Hủy",
      lost: "Mất",
      correction: "Điều chỉnh",
      expired: "Hết hạn",
      other: "Khác",
    },
  },
  customers: {
    title: "Khách hàng",
    titleSupplier: "Nhà cung cấp",
    code: "Mã KH",
    nickname: "Tên gợi nhớ",
    group: "Nhóm",
    vip: "VIP",
    regular: "Thường xuyên",
    new: "Mới",
    totalOrders: "Tổng đơn",
    totalSpent: "Tổng chi",
    rating: "Đánh giá",
    type: "Loại",
    retail: "Bán lẻ",
    wholesale: "Bán sỉ",
    taxId: "MST/CCCD",
    classification: "Phân loại",
    assignedUser: "NV phụ trách",
    maxDebtDays: "Số ngày nợ tối đa",
    maxDebtAmount: "Số tiền nợ tối đa",
    needsCare: "Cần chăm sóc",
    lastOrder: "Lần đặt gần nhất",
    neverOrdered: "Chưa đặt lần nào",
    careTitle: "Chăm sóc khách hàng",
    importExcel: "Nhập từ Excel",
    exportExcel: "Xuất Excel",
    downloadTemplate: "Tải form mẫu",
    importResult: "Kết quả nhập",
  },
  debts: {
    title: "Công nợ",
    customerDebts: "Công nợ khách hàng",
    supplierDebts: "Công nợ nhà cung cấp",
    totalDebt: "Tổng công nợ",
    overdue: "Quá hạn",
    dueSoon: "Sắp đến hạn",
    paid: "Đã thanh toán",
    collect: "Thu tiền",
    payToSupplier: "Trả tiền NCC",
    paymentHistory: "Lịch sử thanh toán",
    daysToDue: "Số ngày tới hạn",
    daysOverdue: "Số ngày quá hạn",
    amount: "Số tiền",
    method: "Phương thức",
    remind: "Nhắc nợ",
  },
  delivery: {
    title: "Quản lý giao hàng",
    shifts: "Ca giao",
    morning: "Sáng",
    afternoon: "Chiều",
    evening: "Tối",
    night: "Đêm",
    assign: "Phân công",
    route: "Tuyến giao",
    deliveryBill: "Phiếu giao hàng",
  },
  users: {
    title: "Quản lý nhân viên",
    role: "Vai trò",
    admin: "Quản trị",
    manager: "Quản lý",
    coordinator: "Điều phối",
    warehouse: "Kho",
    accountant: "Kế toán",
    shipper: "Shipper",
    staff: "Nhân viên",
    newPassword: "Mật khẩu mới",
    paymentMethod: "Phương thức nhận lương",
    permissions: "Phân quyền",
    customPermissions: "Phân quyền tùy chỉnh",
    useDefault: "Dùng mặc định theo vai trò",
    active: "Hoạt động",
    inactive: "Khóa",
  },
  reports: {
    title: "Báo cáo & Thống kê",
    revenue: "Báo cáo doanh thu",
    debt: "Báo cáo công nợ",
    inventory: "Báo cáo tồn kho",
    daily: "Theo ngày",
    weekly: "Theo tuần",
    monthly: "Theo tháng",
    yearly: "Theo năm",
    totalValue: "Giá trị tồn",
    outOfStock: "Hết hàng",
    debtAmount: "Số tiền nợ",
    lastOrder: "Đơn gần nhất",
  },
  chat: {
    title: "Trợ lý Bao",
    subtitle: "Hỏi tôi bất kỳ điều gì",
    placeholder: "Hỏi về đơn hàng, tồn kho, doanh thu...",
    send: "Gửi",
    thinking: "Đang suy nghĩ...",
    welcome: "Xin chào! Tôi là Bao, trợ lý AI nội bộ. Hỏi tôi bất kỳ điều gì.",
    suggestions: [
      "Doanh thu hôm nay thế nào?",
      "Sản phẩm nào sắp hết hàng?",
      "Khách nào chưa đặt 14 ngày qua?",
    ],
    model: "Mô hình AI",
  },
  settings: {
    title: "Cài đặt hệ thống",
    company: "Thông tin cơ sở/công ty",
    bill: "Cấu hình bill in",
    integrations: "Tích hợp",
    backup: "Sao lưu & Bảo mật",
    companyName: "Tên cơ sở/công ty",
    description: "Mô tả",
    languageDefault: "Ngôn ngữ mặc định",
    website: "Website",
    taxId: "Mã số thuế",
    bankInfo: "Thông tin ngân hàng",
    bankName: "Ngân hàng",
    bankAccount: "Số tài khoản",
    bankAccountHolder: "Tên chủ tài khoản",
    logo: "Logo cơ sở",
    billShow: "Hiển thị trên bill",
    billFooter: "Lời chân bill",
    resetDemoTitle: "Xóa toàn bộ dữ liệu demo",
    resetDemoConfirm: "Hành động này sẽ XÓA SẠCH tất cả đơn hàng, khách hàng, sản phẩm và NCC. Không thể khôi phục.",
    serverTime: "Giờ máy chủ",
  },
};

export default vi;
